import profilePhoto from '../images/profile/profile-photo.jpg';
import classyColoursProject from '../images/projects/classycolours.png';
import ecommerceMarketplaceProject from '../images/projects/E-commerce Marketplace.png';
import crimesAgainstWomenProject from '../images/projects/Crimes Against Women Data Analysis.png';
import foreignStudentAssociationProject from '../images/projects/Foreign Student Association.png';
import scholarStudentManagementProject from '../images/projects/Scholar Student Management System.png';
import smartDeviceMarketProject from '../images/projects/Smart Device Market Analysis and Visualisation.png';
import typingProject from '../images/projects/Typing Mastery Test.png';

const cvData = {
  personalInfo: {
    name: 'Muhibullah (Muhib) Noorzad',
    title: 'Software Developer and Computer Science Instructor',
    email: 'mohebullah2015@gmail.com',
    phone: '0470 275 160',
    location: 'Liverpool, NSW 2170, Australia',
    photo: profilePhoto,
    experienceYears: '3+',
    bio: 'Dynamic software developer and computer science instructor with experience in front-end development, UI/UX design, full-stack web applications, and technical mentoring. I enjoy building practical digital products, solving real-world problems, and helping learners grow with clear, hands-on technical guidance.',
    socialLinks: {
      github: 'https://github.com/muhibn',
      linkedin: 'https://linkedin.com/in/muhibn',
      twitter: '',
      portfolio: ''
    }
  },
  skills: {
    frontend: [
      { name: 'React JS', level: 88, icon: 'fab fa-react' },
      { name: 'Next JS', level: 76, icon: 'fas fa-code' },
      { name: 'JavaScript', level: 85, icon: 'fab fa-js' },
      { name: 'Angular', level: 82, icon: 'fas fa-code' },
      { name: 'Bootstrap', level: 88, icon: 'fab fa-bootstrap' },
      { name: 'Angular M', level: 80, icon: 'fas fa-layer-group' }
    ],
    backend: [
            { name: 'C/C++', level: 82, icon: 'fas fa-laptop-code' },
      { name: 'Python', level: 84, icon: 'fab fa-python' },
      { name: 'C#', level: 82, icon: 'fas fa-laptop-code' },
      { name: 'Node JS', level: 78, icon: 'fab fa-node-js' },
      { name: 'Golang', level: 82, icon: 'fas fa-laptop-code' },

      { name: 'Java', level: 70, icon: 'fab fa-java' },
      { name: 'PHP', level: 72, icon: 'fas fa-server' },
      { name: 'Firebase', level: 80, icon: 'fas fa-fire' }
    ],
    tools: [
      { name: 'Git/GitHub', level: 86, icon: 'fab fa-git-alt' },
      { name: 'Docker', level: 70, icon: 'fab fa-docker' },
      { name: 'AWS', level: 78, icon: 'fab fa-aws' },
      { name: 'Azure', level: 78, icon: 'fab fa-microsoft' },
      { name: 'MongoDB', level: 76, icon: 'fas fa-database' },
      { name: 'MySQL', level: 80, icon: 'fas fa-database' },
      { name: 'Firebase', level: 80, icon: 'fas fa-fire' }

    ]
  },
  projects: [
    {
      id: 1,
      title: 'Typing Mastery Test',
      description: 'An interactive web application designed to help users measure and improve their typing performance. It features real-time WPM (Words Per Minute) tracking, accuracy calculation, and error analysis to provide a comprehensive training experience.',
      image: typingProject,
      technologies: ['HTML', 'CSS', 'JavaScript', 'Bootstrap'],
      githubUrl: 'https://github.com/muhibn/typingmasterytest',
      liveUrl: 'https://typingmasterytest.web.app/',
      category: 'web',
      featured: true
    },
    {
      id: 2,
      title: 'Classy Colours',
      description: 'A comprehensive web development project focused on managing and visualizing color palettes and design systems. This application provides a professional interface for exploring color technologies and was developed as part of a Web Technology academic course.',
      image: classyColoursProject,
      technologies: ['HTML', 'CSS', 'JavaScript', 'Node.js', 'Bootstrap', 'MySQL'],
      githubUrl: 'https://github.com/muhibn/Web-Technology-Project',
      liveUrl: 'https://classy-colour.web.app/',
      category: 'web',
      featured: true
    },
    {
      id: 3,
      title: 'E-commerce Marketplace',
      description: 'Designed an e-commerce platform for direct transactions between buyers and sellers using a full web stack.',
      image: ecommerceMarketplaceProject,
      technologies: ['HTML', 'CSS', 'JavaScript', 'Node.js', 'Bootstrap', 'MySQL'],
      githubUrl: 'https://github.com/muhibn/Web-Technology-Project',
      liveUrl: 'https://github.com/muhibn/Web-Technology-Project',
      category: 'web',
      featured: true
    },
    {
      id: 4,
      title: 'Crimes Against Women Data Analysis',
      description: 'Analysed crime data in India at state and city level using R, statistical methods, and data visualisation.',
      image: crimesAgainstWomenProject,
      technologies: ['R', 'Data Analysis', 'Visualisation', 'Statistics'],
      githubUrl: 'https://github.com/muhibn/Crimes-Against-Women-Analysis',
      liveUrl: 'https://github.com/muhibn/Crimes-Against-Women-Analysis',
      category: 'web',
      featured: true
    },
    {
      id: 5,
      title: 'Foreign Student Association',
      description: 'Built an information platform for foreign students seeking education guidance in India using PHP and MySQL.',
      image: foreignStudentAssociationProject,
      technologies: ['HTML', 'CSS', 'JavaScript', 'PHP', 'MySQL'],
      githubUrl: 'https://github.com/muhibn/Foreign-Student-Association',
      liveUrl: 'https://github.com/muhibn/Foreign-Student-Association',
      category: 'web',
      featured: true
    },
    {
      id: 6,
      title: 'Scholar Student Management System',
      description: 'Developed a web application to manage scholar student records with a database-driven workflow.',
      image: scholarStudentManagementProject,
      technologies: ['PHP', 'MySQL', 'HTML', 'CSS'],
      githubUrl: 'https://github.com/muhibn/Scholar-Students-Database',
      liveUrl: 'https://github.com/muhibn/Scholar-Students-Database',
      category: 'web',
      featured: false
    },
    {
      id: 7,
      title: 'Smart Device Market Analysis and Visualisation',
      description: 'Created a Python project to analyse and visualise smart device market data across hardware and pricing dimensions.',
      image: smartDeviceMarketProject,
      technologies: ['Python', 'Data Analysis', 'Visualisation'],
      githubUrl: 'https://github.com/muhibn/Smart-device-Market-Analysis',
      liveUrl: 'https://github.com/muhibn/Smart-device-Market-Analysis',
      category: 'web',
      featured: false
    }
  ],
  experience: [
    {
      id: 1,
      company: 'Nighwan Technology Pvt. Ltd.',
      position: 'Software Engineer Intern',
      startDate: 'Mar 2024',
      endDate: 'Jul 2024',
      description: 'Contributed to HRMS product development with Angular, Angular Material, Bootstrap, and REST-based services.',
      achievements: [
        'Developed the Offer Approval component for the HRMS platform.',
        'Resolved UI and responsive issues across task board, employee dashboard, and resume modules.',
        'Built CRUD service integrations for the Asset Vendor Management System.'
      ]
    },
    {
      id: 2,
      company: 'Afghan Unite Centre and New Master Mind Academy',
      position: 'Computer Science Instructor',
      startDate: 'Jan 2022',
      endDate: 'Dec 2023',
      description: 'Delivered technical instruction across software, web development, programming, and digital literacy subjects.',
      achievements: [
        'Trained and mentored more than 100 students in computer science and IT topics.',
        'Improved exam performance through practical projects and interactive teaching methods.',
        'Taught Microsoft Office, HTML, CSS, Bootstrap, JavaScript, Python, C++, and system fundamentals.'
      ]
    }
  ],
  education: [
    {
      id: 1,
      institution: 'University of Delhi',
      degree: 'Master of Computer Science',
      field: 'Computer Science',
      startDate: 'Jan 2022',
      endDate: 'Jun 2024',
      grade: '',
      achievements: [
        'Focused on software engineering, project delivery, and advanced computing topics.'
      ]
    },
    {
      id: 2,
      institution: 'University of Delhi',
      degree: 'B.Sc (Hons) Computer Science',
      field: 'Computer Science',
      startDate: 'Feb 2020',
      endDate: 'Aug 2022',
      grade: '',
      achievements: [
        'Built a strong foundation in programming, database systems, and software development.'
      ]
    },
    {
      id: 3,
      institution: 'Zukor Hassani High School',
      degree: 'High School',
      field: '',
      startDate: 'Aug 2012',
      endDate: 'Aug 2014',
      grade: '',
      achievements: [
        'Completed secondary education with a strong interest in computing and mathematics.'
      ]
    }
  ],
  certifications: [
    {
      id: 1,
      name: 'Data Analysis and Machine Learning Courses',
      issuer: 'Online Learning Platforms',
      date: 'Ongoing',
      link: 'https://github.com/muhibn'
    },
    {
      id: 2,
      name: 'Python Programming Certifications',
      issuer: 'Online Learning Platforms',
      date: 'Completed',
      link: 'https://github.com/muhibn'
    },
    {
      id: 3,
      name: 'Software Engineering Training',
      issuer: 'University of Delhi',
      date: 'Completed',
      link: 'https://github.com/muhibn'
    }
  ],
  services: [
    {
      id: 1,
      title: 'Web Development',
      icon: 'fas fa-laptop-code',
      description: 'Building responsive, maintainable websites and applications with practical user-focused interfaces.',
      proficiency: 100,
      tags: ['React', 'Node.js', 'TypeScript']
    },
    {
      id: 2,
      title: 'Technical Teaching',
      icon: 'fas fa-chalkboard-user',
      description: 'Explaining complex ideas clearly and helping students grow through hands-on examples and mentoring.',
      proficiency: 92,
      tags: ['Mentoring', 'Curriculum', 'Workshops']
    },
    {
      id: 3,
      title: 'Project Delivery',
      icon: 'fas fa-diagram-project',
      description: 'Turning requirements into working solutions with clean implementation, iteration, and steady delivery.',
      proficiency: 88,
      tags: ['Agile', 'CI/CD', 'Testing']
    }
  ],
  languages: [
    {
      name: 'English',
      level: 'Professional',
      proficiency: 85
    },
    {
      name: 'Dari',
      level: 'Native',
      proficiency: 100
    },
    {
      name: 'Hindi',
      level: 'Working',
      proficiency: 75
    }
  ]
};

export default cvData;
